import I18n from 'i18n-js';
import { IUser } from '@reverbdotcom/commons/src/components/user_context_provider';
import experiments from './experiments';
import { experimentInt, isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';
import {
  reverb_search_ListingsSearchRequest as ListingsSearchRequest,
  reverb_search_ListingItemRegionRelation as ItemRegionRelation,
  reverb_search_SimilarListingsSearchRequest as SimilarListingsSearchRequest,
} from './rql';

const MULTIVARIATE_EXPERIMENT_GROUP_TWO = 2;

function isNonUSUser(user: Partial<IUser>) {
  return user.countryCode && user.countryCode !== 'US';
}

function isUserEligibleForLocalizeListingsRowsExperiment(user: Partial<IUser>) {
  return isNonUSUser(user);
}

function isUserEligibleForLocalizeCSPCardExperiment(user: Partial<IUser>) {
  return isNonUSUser(user);
}

function isUserEligibleForSeoOptimizationExperiment(user: Partial<IUser>) {
  return user.countryCode && user.countryCode === 'GB';
}

export function trackLocalizeCSPCardExperiment(user: Partial<IUser>) {
  if (isUserEligibleForLocalizeCSPCardExperiment(user)) {
    return [experiments.LOCALIZE_CSP_CARD];
  }

  return [];
}

export function trackLocalizeListingsRowExperiment(user: Partial<IUser>) {
  if (isUserEligibleForLocalizeListingsRowsExperiment(user)) {
    return [experiments.LOCALIZE_LISTINGS_ROWS_SITEWIDE];
  }

  return [];
}

export function trackSeoOptimizationExperiment(user: Partial<IUser>) {
  if (isUserEligibleForSeoOptimizationExperiment(user)) {
    return [experiments.SEO_ITEM_PAGE_OPTIMIZATION];
  }

  return [];
}

export function isUserInLocalizeCSPCardExperiment(user: Partial<IUser>) {
  const isEnabled = isExperimentEnabled(user, experiments.LOCALIZE_CSP_CARD);

  return isUserEligibleForLocalizeCSPCardExperiment(user) && isEnabled;
}

export function isUserInLocalizeListingsRowsExperiment(user: Partial<IUser>) {
  const isEnabled = isExperimentEnabled(user, experiments.LOCALIZE_LISTINGS_ROWS_SITEWIDE);

  return isUserEligibleForLocalizeListingsRowsExperiment(user) && isEnabled;
}

export function isUserInSeoOptimizationExperiment(user: Partial<IUser>) {
  return isUserEligibleForSeoOptimizationExperiment(user) &&
    isExperimentEnabled(user, experiments.SEO_ITEM_PAGE_OPTIMIZATION);
}

export function localizeListingsRowsExperimentFilters(user: Partial<IUser>): ListingsSearchRequest {
  const isUserInExperiment = isUserInLocalizeListingsRowsExperiment(user);

  const userExperimentBucket = experimentInt(user, experiments.LOCALIZE_LISTINGS_ROWS_SITEWIDE);
  const isUserInExperimentGroupTwo = userExperimentBucket === MULTIVARIATE_EXPERIMENT_GROUP_TWO;

  if (isUserInExperiment && isUserInExperimentGroupTwo) {
    return {
      itemRegion: user.countryCode,
      itemRegionRelation: ItemRegionRelation.INCLUDE_TRADE_REGIONS,
    };
  }

  return {};
}

export function seoOptimizationExperimentFilters(user: Partial<IUser>): SimilarListingsSearchRequest {
  const isGBUserInSEOExperiment = isUserInSeoOptimizationExperiment(user);

  if (isGBUserInSEOExperiment) {
    return { itemRegion: 'GB' };
  }

  return {};
}

export function seoOptimizationSimilarListingsTitle(user: Partial<IUser>) {
  if (isUserInSeoOptimizationExperiment(user)) {
    return I18n.t('commons.listingRow.similarListingsUK');
  }
  return undefined;
}
